import RenderSteps from "./RenderSteps"

export default function AddCourse() {
  return (
    <>
      <div className="flex flex-col gap-2 mb-8">
        <div className="section-kicker">Instructor</div>
        <h1 className="font-display text-4xl font-extrabold text-slate-900 tracking-tight">
          Add Course
        </h1>
      </div>

      <div className="flex w-full items-start gap-x-8">
        <div className="flex flex-1 flex-col">
          <div className="flex-1">
            <RenderSteps />
          </div>
        </div>
        {/* Course Upload Tips */}
        <div className="sticky top-10 hidden max-w-[400px] flex-1 rounded-[32px] border border-slate-200 bg-white p-8 shadow-sm xl:block">
          <p className="mb-6 text-xl font-bold text-slate-900 flex items-center gap-2">
            <span className="text-yellow-500">⚡</span> Course Upload Tips
          </p>
          <ul className="ml-5 list-item list-disc space-y-4 text-sm font-medium text-slate-600">
            <li>Set the Course Price option or make it free.</li>
            <li>Standard size for the course thumbnail is 1024x576.</li>
            <li>Video section controls the course overview video.</li>
            <li>Course Builder is where you create & organize a course.</li>
            <li>
              Add Topics in the Course Builder section to create lessons,
              quizzes, and assignments.
            </li>
            <li>
              Information from the Additional Data section shows up on the
              course single page.
            </li>
            <li>Make Announcements to notify any important</li>
            <li>Notes to all enrolled students at once.</li>
          </ul>
        </div>
      </div>
    </>
  )
}
